import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as changeImpacts from '../../../../change-impacts'
import * as changeImpactPersona from '../change-impact-persona'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: changeImpactPersona.RESOURCE.payload.dimension.partialId,
      partialId: changeImpactPersona.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Change impact that affects the persona',
    isOptional: false,
    name: 'Change Impact',
    partialId: PartialId.Standard.create('change_impact'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        changeImpacts.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
